export default __webpack_public_path__ + "static/media/icn_list_guide_2.91e4513f.svg";